import { css } from 'styled-components';
export function getThemeCssVariables(themeTokens) {
  return css(["", ""], mapTokensToCss(themeTokens));
}
function mapTokensToCss(themeTokens) {
  return Object.keys(themeTokens).map(function (key) {
    return "--lmn-ds-".concat(key, ": ").concat(themeTokens[key], ";\n");
  }).reduce(function (acc, curr) {
    return acc + curr;
  }, '');
}